import React, { useEffect, useState } from 'react'
import moment from 'moment'
import numeral from 'numeral'
import _ from 'lodash'
import {
 Drawer, Dropdown, Menu, AutoComplete, Button, Select, Spin,
} from 'antd'
import {
 P, Div, H3, H4, SmallText, Input,
} from 'konsys-ui'
import { Query } from 'react-apollo'
import { useLazyQuery, useQuery } from '@apollo/react-hooks'
import { Link } from 'react-router-dom'
import {
    Boxes,
 ChevronDown,
 ChevronUp,
 Ellipsis, IdCard, MapPinned, Search, Truck,
 User,
} from 'lucide-react'
import {
 SHIPPING_ORDERS, SHIPPING_ORDER, JOB_SEARCH, GET_CLIENTS,
} from '../../../constants/graphql/query'
import { MYINFO } from '../../../constants/graph/query'
import { theme } from '../../../styles/_variables'
import { CardStyled } from '../styled'
import { status as shippingStatus, statusText } from '../constants'
import { TagMobile, Loading, FileListWithModal } from '../../../components/common'
import { textStatusSelector, colorSelector } from './config'
import {
 PickedUpModal, ScanModal, DropdownSelector, DeliveryModal,
} from '../../../components/shipping-order-components'
import ROLE from '../../../constants/role'

const { color } = theme

const Card = ({
  data, defaultExpand, myInfo, noMenu, list,
}) => {
  const [expand, setExpand] = useState(defaultExpand || false)
  const [pickedUpModal, setPickedUpModal] = useState(false)
  const [deliveryModal, setDeliveryModal] = useState(false)
  const [scanModal, setScanModal] = useState(false)
  const [getInfo, {
    data: info, loading, refetch,
  }] = useLazyQuery(SHIPPING_ORDER)

  const menu = (
    <Menu onClick={(e) => {
      if (e?.key === 'scan') {
        setScanModal(true)
      } else if (e?.key === 'pickup') {
        getInfo({ variables: { id: `${data.id}` } })
        setPickedUpModal(true)
      } else if (e?.key === 'delivery') {
        getInfo({ variables: { id: `${data.id}` } })
        setDeliveryModal(true)
      }
    }}>
    {
      myInfo?.myInfo?.Roles[0].id === ROLE.DRIVER.id
      && <Menu.Item key="detail">
          <Link target="_blank" to={`/shipping-order/view/${data.id}`}>
            ดูรายละเอียด
          </Link>
        </Menu.Item>
    }
      <Menu.Item key="scan">
        Scan QR code
      </Menu.Item>
      {
        data.status === shippingStatus.ASSIGNED && myInfo?.myInfo?.Roles[0].id === 11
        && <Menu.Item
              key="pickup"
              disabled={
                list
                && _.some(list,
                  o => o.id !== data.id
                    && o.status === shippingStatus.PICKEDUP
                    && o.startDestinationLocation.id === data.startDestinationLocation.id
                    && o.endDestinationLocation.id === data.endDestinationLocation.id)
              }
            >
            บันทึกการขึ้นของ
          </Menu.Item>
      }
      {
        data.status === shippingStatus.PICKEDUP && myInfo?.myInfo?.Roles[0].id === 11
        && <Menu.Item key="delivery">
            บันทึกการลงของ
          </Menu.Item>
      }
    </Menu>
  )
  return (
    <CardStyled display='flex' flexDirection='column' padding='8px 16px' margin='8px 0' width='100%'>
      <PickedUpModal
        shippingDetailData={info}
        pickedUpModal={pickedUpModal}
        setPickedUpModal={setPickedUpModal}
        refetch={refetch}
        isDataLoaded={info && !loading}
        shippingDetailLoading={loading}
      />
      <DeliveryModal
        shippingDetailData={info}
        deliveryModal={deliveryModal}
        setDeliveryModal={setDeliveryModal}
        refetch={refetch}
        isDataLoaded={info && !loading}
        shippingDetailLoading={loading}
      />
      <ScanModal
        shippingDetailData={data}
        visible={scanModal}
        setVisible={setScanModal}
      />
      <Div justifyContent='space-between' width='100%' alignItems='center' display='flex' margin='0 0 16px 0'>
        <Div alignItems='center' display='flex' width='calc(100% - 100px)'>
          <IdCard className='size-6 mr-4' color={theme.color.primaryColor} />
          <Div alignItems='flex-start' display='flex' flexDirection='column' justifyContent='flex-start'>
            <P>{data?.Truck?.plateNumber}</P>
            <SmallText>{data?.shippingVolume}/{data?.shippingNumber}</SmallText>
          </Div>
        </Div>
        <TagMobile text={textStatusSelector(data.status)} color={colorSelector(data.status)}/>
        {
          !noMenu
            && <Dropdown overlay={menu} trigger={['click']} on>
                <Ellipsis className='cursor-pointer size-4 mx-2' color={theme.color.primaryColor} />
              </Dropdown>
        }
      </Div>
      <Div justifyContent='space-between' width='100%' alignItems='flex-end' display='flex' margin='0 0 16px 0' onClick={() => setExpand(!expand)}>
        <Div>
          <Div width='100%' alignItems='center' display='flex' margin='0 0 8px 0'>
            <Truck className='size-5 mr-4' color={theme.color.coolGrey} />
            <SmallText color={theme.color.coolGrey}>{data?.startDestinationLocation?.name || '-'}</SmallText>
          </Div>
          <Div width='100%' alignItems='center' display='flex'>
            <MapPinned className='size-5 mr-4' color={theme.color.coolGrey} />
            <SmallText color={theme.color.coolGrey}>{data?.endDestinationLocation?.name || '-'}</SmallText>
          </Div>
        </Div>
        {
          expand
          ? <ChevronDown className='size-5 mr-4' color={theme.color.primaryColor} />
          : <ChevronUp className='size-5 mr-4' color={theme.color.primaryColor} />
        }
      </Div>
      {
        expand
          && <Div>
              <Div width='100%' alignItems='center' display='flex' margin='8px 0'>
                <Boxes className='size-5 mr-4' color={theme.color.coolGrey} />
                <SmallText color={theme.color.coolGrey}>{data?.Job?.cargo || '-'}</SmallText>
              </Div>
              <Div width='100%' alignItems='center' display='flex' margin='0 0 8px 0'>
                <User className='size-5 mr-4' color={theme.color.coolGrey} />
                <SmallText margin='0 0 0 10px' color={theme.color.coolGrey}>{data?.Driver?.fullname || '-'}</SmallText>
              </Div>
              <Div justifyContent='space-between' width='100%' alignItems='flex-end' display='flex' margin='16px 0' flexDirection='column'>
                <Div justifyContent='space-between' width='100%' alignItems='center' display='flex' margin='0'>
                  <SmallText color={theme.color.coolGrey}>น้ำหนักต้นทาง {data?.startWeight ? numeral(data?.startWeight / 1000).format('0,0.00') : '-'} ตัน</SmallText>
                  <SmallText color={theme.color.coolGrey}>ขึ้นของ {data?.pickedUpDate ? `${moment(data?.pickedUpDate).format('DD/MM/YY')} ${moment(data?.pickedUpTime, 'HH:mm:ss').format('HH:mm')}` : '-'}</SmallText>
                </Div>
                <Div justifyContent='space-between' width='100%' alignItems='center' display='flex' margin='0'>
                  <SmallText color={theme.color.coolGrey}>น้ำหนักปลายทาง {data?.endWeight ? numeral(data?.endWeight / 1000).format('0,0.00') : '-'} ตัน</SmallText>
                  <SmallText color={theme.color.coolGrey}>นำส่ง {data?.deliveryDate ? `${moment(data?.deliveryDate).format('DD/MM/YY')} ${moment(data?.deliveryTime, 'HH:mm:ss').format('HH:mm')}` : '-'}</SmallText>
                </Div>
              </Div>
              <Div justifyContent='flex-start' width='100%' display='flex' margin='16px 0' flexDirection='column'>
                <Div alignItems='flex-start' display='flex' flexDirection='column' justifyContent='flex-start'>
                  <SmallText color={theme.color.coolGrey}>เอกสาร</SmallText>
                  <FileListWithModal files={data?.images} />
                </Div>
              </Div>
            </Div>
      }
    </CardStyled>
  )
}

export const MobileShippingList = (props) => {
  const isCargoView = !_.isNil(props?.shippingNumber) && !_.isNil(props?.shippingVolume)

  const [doGetShippingOrders, {
    data, loading, fetchMore,
  }] = useLazyQuery(SHIPPING_ORDERS, {
    variables: isCargoView
    ? {
        shippingNumber: props?.shippingNumber,
        shippingVolume: props?.shippingVolume,
        orderBy: 'ASC',
        orderField: 'shippingNumber',
      }
    : {
      orderBy: 'ASC',
      orderField: 'shippingNumber',
    },
  })

  const [search, setSearch] = useState(false)

  const [id, setID] = useState('')
  const [searchText, setSearchText] = useState()
  const [key, setKey] = useState()
  const [shippingNumber, setShippingNumber] = useState()
  const [shippingVolume, setShippingVolume] = useState()
  const [plateNumber, setPlateNumber] = useState()
  const [companyName, setCompanyName] = useState()
  const [status, setStatus] = useState('ALL')

  const {
    data: myInfo, loading: myInfoLoading,
  } = useQuery(MYINFO)

  useEffect(() => {
    doGetShippingOrders({ variables: { limit: 100, offset: 0 } })
  }, [])

  const noMenu = _.indexOf([ROLE.CARGO_OFFICER.id, ROLE.CUSTOMER.id], myInfo?.myInfo?.Roles[0].id) > -1

  return (
    <Div display='flex' flexDirection='column'>
      <Drawer
        title='ค้นหา'
        placement='top'
        closable={false}
        onClose={() => setSearch(false)}
        visible={search}
        height={350}
      >
        {
          !myInfoLoading && myInfo?.myInfo?.Roles[0].id === ROLE.DRIVER.id
          ? <Query
            query={GET_CLIENTS}
            variables={{
              companyName: id,
              limit: 5,
              type: 'CLIENT',
            }}
          >{({ data: clientData, loading: clientLoading, error: clientError }) => {
            if (clientLoading && _.isEmpty(clientData)) return <Loading center='true' />
            if (clientError) return <P>เกิดข้อผิดพลาด</P>

            const mappedData = clientData.getCustomerLists.lists.map(v => ({
              id: v.id, companyName: v.companyName, companyId: v.companyId, type: v.TypeOfCharge.name, branch: v.branch,
            }))
            return (
              <Div display='flex' margin='4px 0 16px 0' alignItems='flex-start' justifyContent='space-between' flexDirection='column'>
                <P margin='0 0 4px 0'>ผู้จ้าง</P>
                <Select
                  value={companyName}
                  showSearch
                  optionFilterProp="children"
                  notFoundContent={clientLoading ? <Spin size="small" /> : null}
                  onSearch={e => setID(e)}
                  onChange={(e, i) => setCompanyName(i.props.name)}
                  style={{ width: '100%' }}
                >
                  {
                    mappedData.map((v, i) => <Select.Option key={i} value={v.id} name={v.companyName}>{v.companyName}</Select.Option>)
                  }
                </Select>
              </Div>
            )
          }}
          </Query>
          : <Div>
              {
                myInfo?.myInfo?.Customer
                && <Div display='flex' margin='4px 0' alignItems='center' justifyContent='space-between'>
                  <P>ผู้จ้าง</P>
                  <DropdownSelector
                    key='filter'
                    data={myInfo?.myInfo?.Customer?.map(customer => ({ value: customer.companyName, text: customer.companyName }))}
                    moreProps={{ value: companyName, style: { width: '250px' }, defaultValue: '' }}
                    handleChange={e => setCompanyName(e)}
                    filter={true}
                  />
                </Div>
              }
              <Div display='flex' margin='4px 0' alignItems='center' justifyContent='space-between'><P>ทะเบียนรถ</P><Input width='50%' value={plateNumber} onChange={e => setPlateNumber(e.target.value)} /></Div>
            </Div>
        }
        <Query
          query={JOB_SEARCH}
          fetchPolicy='cache-and-network'
          variables={{
            key: searchText,
          }}
        >{(job) => {
          if (job.loading && _.isUndefined(job.data.searchJobByVolumnNumber)) return <Loading size='small'/>
          if (job.error) return <P>เกิดข้อผิดพลาด</P>
          return (
            <Div display='flex' margin='4px 0' alignItems='center' justifyContent='space-between'>
              <P margin='0 8px 0 0'>สัญญางาน</P>
              {job.loading && <Loading size='small' style={{ marginRight: 8 }}/>}
              <AutoComplete
                dataSource={job.data.searchJobByVolumnNumber.lists.map(v => v.key)}
                value={searchText}
                style={{ width: '50%' }}
                onSelect={(e) => {
                  setKey(e)
                  setSearchText(e)
                }}
                onSearch={(e) => {
                  setSearchText(e)
                }}
                placeholder="ใส่เลขที่สัญญางาน"
              />
            </Div>
          )
        }}
        </Query>
        <Div display='flex' margin='4px 0' alignItems='center' justifyContent='space-between'><P margin='0 8px 0 0'>เล่มที่</P><Input value={shippingVolume || ''} width='50%' onChange={e => setShippingVolume(e.target.value)} /></Div>
        <Div display='flex' margin='4px 0' alignItems='center' justifyContent='space-between'><P>เลขที่</P><Input value={shippingNumber || ''} width='50%' onChange={e => setShippingNumber(e.target.value)} /></Div>
          <Div display='flex' margin='4px 0' alignItems='center' justifyContent='space-between'>
              <P>สถานะ</P>
              <DropdownSelector
                width='50%'
                key='filter'
                data={[
                  { value: shippingStatus.ALL, text: statusText.ALL },
                  { value: shippingStatus.WAITING, text: statusText.WAITING },
                  { value: shippingStatus.ASSIGNED, text: statusText.ASSIGNED },
                  { value: shippingStatus.EXPIRED, text: statusText.EXPIRED },
                  { value: shippingStatus.PICKEDUP, text: statusText.PICKEDUP },
                  { value: shippingStatus.DELIVERED, text: statusText.DELIVERED },
                  { value: shippingStatus.CANCELLED, text: statusText.CANCELLED },
                  { value: shippingStatus.BILLED, text: statusText.BILLED },
                ]}
                value={status}
                handleChange={e => setStatus(e || 'ALL')}
                filter={true}
                statusAttr='ทั้งหมด'
              />
            </Div>
        <div
          style={{
            textAlign: 'right',
            alignSelf: 'flex-end',
            marginTop: 8,
          }}
        >
          <Button
            onClick={() => {
              doGetShippingOrders({ variables: { limit: 10, offset: 0 } })
              setShippingNumber()
              setShippingVolume()
              setPlateNumber('')
              setSearchText()
              setStatus('ALL')
              setKey()
              setCompanyName()
              setSearch(false)
            }}
            style={{ marginRight: 8 }}
          >
            ล้างค่า
          </Button>
          <Button
            onClick={() => {
              doGetShippingOrders({
                variables: {
                  limit: 10,
                  offset: 0,
                  key,
                  shippingVolume,
                  shippingNumber,
                  plateNumber,
                  status: _.isEmpty(status) || status === 'ALL' ? undefined : status,
                  companyName,
                },
              })
              setSearch(false)
              }
            }
            type="primary"
          >
            ค้นหา
          </Button>
        </div>
      </Drawer>
      <Div display='flex' flexDirection='row' justifyContent='space-between' alignItems='center'>
        <H3 bold color={color.primaryColor} margin='32px 0'>รายการใบสั่งบรรทุก</H3>
        <Div display='flex' flexDirection='row' alignItems='center'>
          {!isCargoView && <Search className='size-6' color={theme.color.primaryColor} onClick={() => setSearch(true)}/>}
        </Div>
      </Div>
      <Div
        margin='-8px 0'
        height='calc(100vh - 266px)'
        style={{ overflowY: 'auto' }}
        onScroll={(e) => {
          if (e.target.offsetHeight + e.target.scrollTop >= e.target.scrollHeight && data.ShippingorderList.lists.length < data.ShippingorderList.totalFilter) {
            fetchMore({
              variables: {
                offset: data.ShippingorderList.lists.length,
                limit: 10,
              },
              updateQuery: (prev, { fetchMoreResult }) => {
                if (!fetchMoreResult) return prev
                const newData = {
                  ...prev,
                  ShippingorderList: {
                    ...prev.ShippingorderList,
                    lists: [
                      ...prev.ShippingorderList.lists,
                      ...fetchMoreResult.ShippingorderList.lists,
                    ],
                  },
                }
                return { ...newData }
              },
            })
          }
        }}
      >
        {
          _.isEmpty(data?.ShippingorderList?.lists)
          ? <P bold color={theme.color.purplishGrey}>ไม่พบรายการที่ค้นหา</P>
          : data?.ShippingorderList?.lists.map(order => (
              <Card key={order.id} data={order} defaultExpand={isCargoView} myInfo={myInfo} noMenu={noMenu} list={data?.ShippingorderList?.lists} />
            ))
        }
      </Div>
      {loading && <Loading />}
    </Div>
  )
}

export default MobileShippingList
